import { Component } from "react";
import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import { isBrowser } from "^/utils/isBrowser";
import validations from "../../../utils/validations";
import getLanguage from "../../../utils/getLanguage";
import scrollToTop from "../../../utils/scrollToTop";
import GoNextButton from "./NavigationButtons/GoNextButton";
import GoBackButton from "./NavigationButtons/GoBackButton";
import SubmitButton from "./NavigationButtons/SubmitButton";

class FormPageWidget extends Component {
  state = {
    singlePageAnswers: {},
    inputsWithErrors: [],
  };

  validateInputs() {
    const wrongInputs = [];
    const { widget } = this.props;

    widget.get("inputs").forEach((input) => {
      wrongInputs.push({
        id: input.id(),
        validation: this.singleInputValidation(input),
      });
    });

    this.setState({
      inputsWithErrors: wrongInputs.filter((item) => item.validation !== null),
    });

    return wrongInputs.filter((item) => item.validation !== null).length === 0;
  }

  singleInputValidation(input) {
    const inputId = input.id();
    const myStorage = isBrowser ? window.sessionStorage : {};
    const value =
      this.state.singlePageAnswers[inputId] || myStorage.getItem(inputId);
    const propertyName = input.get("propertyName");

    if (propertyName === "email" && value) {
      return validations.validateEmail(value) ? null : "invalidFormat";
    }

    if (input.get("optional") === "no") {
      if (input.objClass() === "CheckboxWidget") {
        return JSON.parse(value || "[]").length > 0 ? null : "required";
      }
      if (!value || value.trim().length < 3) {
        return "required";
      }
    }
    return null;
  }

  processAnswer = ({ widget, value }) => {
    const { singlePageAnswers } = this.state;
    const newState = {};
    const newAnswers = { ...singlePageAnswers };
    const widgetId = widget.id();

    if (widget.objClass() === "CheckboxWidget") {
      // handle checkbox
      const values = JSON.parse(singlePageAnswers[widgetId] || "[]");
      let newValues = [];
      if (values.indexOf(value) === -1) {
        newValues = [...values, value];
      } else {
        newValues = values.filter((n) => n !== value);
      }
      newAnswers[widgetId] = JSON.stringify(newValues);
    } else {
      newAnswers[widgetId] = value;
    }

    newState.singlePageAnswers = newAnswers;

    this.setState(newState, () => {
      if (this.singleInputValidation(widget) === null) {
        this.setState((prevState) => ({
          inputsWithErrors: prevState.inputsWithErrors.filter(
            (item) => item.id !== widgetId
          ),
        }));
      }
    });
  };

  renderInputList(attribute) {
    return (
      <Scrivito.ContentTag
        content={this.props.widget}
        attribute={attribute}
        widgetProps={{
          processAnswer: this.processAnswer,
          inputsWithErrors: this.state.inputsWithErrors,
        }}
      />
    );
  }

  navigation = () => {
    if (
      this.props.currentStep === 1 &&
      this.props.currentStep === this.props.formPagesCount
    ) {
      return <SubmitButton submitAnswers={this.submit} />;
    }
    if (this.props.currentStep === 1) {
      return <GoNextButton nextPage={this.nextPage} />;
    }
    if (this.props.currentStep === this.props.formPagesCount) {
      return (
        <>
          <GoBackButton previousPage={this.previousPage} />
          <SubmitButton submitAnswers={this.submit} />
        </>
      );
    }
    return (
      <>
        <GoBackButton previousPage={this.previousPage} />
        <GoNextButton nextPage={this.nextPage} />
      </>
    );
  };

  nextPage = (e) => {
    e.preventDefault();
    this.validateInputs();
    if (this.validateInputs()) {
      this.props.goNextStep();
    }
    scrollToTop("container");
  };

  previousPage = (e) => {
    e.preventDefault();
    this.props.goPrevStep();
    scrollToTop("container");
  };

  submit = (e) => {
    e.preventDefault();
    this.validateInputs();
    if (this.validateInputs()) {
      this.props.submitAnswers();
    }
    scrollToTop("container");
  };

  render() {
    const { widget } = this.props;
    const lang = getLanguage(Scrivito.currentPage());
    const requiredFieldsExists = widget
      .get("inputs")
      .find((item) => item.get("optional") === "no");

    return (
      <div id="container" className="container">
        <Scrivito.ContentTag
          tag="h2"
          content={widget}
          attribute="headline"
          className="headline-form"
        />
        <form className="form-widget">{this.renderInputList("inputs")}</form>
        {requiredFieldsExists && (
          <div
            className="pt-4 pb-4"
            dangerouslySetInnerHTML={{ __html: I18n.t("requiredFieldsText") }}
          />
        )}
        <div className="d-flex justify-content-center align-items-center form-page-counter">
          <span className="form-page-counter-text">
            {lang === "de" ? "Schritt" : "Step"} {this.props.currentStep}{" "}
            {lang === "de" ? "von" : "of"} {this.props.formPagesCount}
          </span>
        </div>
        <div className="d-flex justify-content-between form-page-buttons align-items-center">
          {this.navigation()}
        </div>
      </div>
    );
  }
}

Scrivito.provideComponent("FormPageWidget", FormPageWidget);
export default Scrivito.connect(FormPageWidget);
